<template>
  <div class="new-popupbox team-popupbox">
    <div class="hanlder-box">
      <svg class="icon-svg popup-close" @click="close()">
        <use xlink:href="#icon-guanbi" />
      </svg>
    </div>
    <div class="team-box" :style="{ backgroundColor: theme_color }">
      <div class="team-title">团队信息</div>
      <div class="team-list">
        <div class="team-item" :class="{ singleItem: teamList.length == 1 }" v-for="item of teamList">
          <div class="team-info">
            <a-tooltip>
              <template #title>{{ item.groupSchemeName }}</template>
              <div class="team-groupSchemeName">{{ item.groupSchemeName }}</div>
            </a-tooltip>
            <a-tooltip>
              <template #title>{{ item.TeamName }}</template>
              <div class="team-name">{{ item.TeamName }}</div>
            </a-tooltip>
            <div class="code-list">
              <a-tooltip v-for="code of item.allcode">
                <template #title>{{ code.ProjectName }}：{{ code.Title }}</template>
                <div class="code-item">
                  <svg class="icon-svg code-icon">
                    <use :xlink:href="code.icon" />
                  </svg>
                </div>
              </a-tooltip>
            </div>
          </div>
          <div class="member-list">
            <div class="member-item" v-for="member of item.stuList">
              <i class="member-cover icon-i" :style="{ backgroundImage: 'url(' + member?.HeadPhotoPath + ')' }">
                <svg class="member-leader icon-svg" v-if="member.isLeader">
                  <use xlink:href="#icon-qizi"></use>
                </svg>
              </i>
              <span class="member-name">{{ member.Name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  name: "team-box",
  data() {
    return {
      theme_color:'',
      teamList: [],
    }
  },
  async mounted() {
    let { platform } = this.$store.state;
    this.theme_color = platform.pageConfig.theme_color;

    this.getTeamList();
  },
  methods: {
    //获取所有成就
    async getTeamList() {
      let { myTeamList } = this.$store.state;
      this.teamList = myTeamList;
    },
    //关闭弹窗
    close() {
      this.$emit("closeBox", true);
    }
  },
}
</script>

<style scoped lang="scss">
@import "./team-box.scss";
</style>